import moment from "moment";
import { Link, useParams } from "react-router-dom";

export const BestItem = ({item})=>{
    const { school } = useParams();
    return (
        <div className="slide_item">
            <div className="book_wrap">
                <Link  to={`/${school}/bookreport/view/${item.id}`}>
                    <div className="book_cover">
                        <div className="book_inner">
                            <img src={item.book.image}  alt="책표지" />
                        </div>
                    </div>
                    <div className="book_info">
                        <p className="title">{item.book.title}</p>
                        <p className="info"><span>{item.book.author}</span><span>{item.book.publisher}</span></p>
                    </div>
                </Link>
            </div>
            <div className="report_area">{item.content}</div>
            <div className="user_info">
                <p className="name">{item.user.name}</p>
                <p className="info"><span className="school">{item.user?.schoolName}</span><span className="date">({moment(item.createdAt).format('YYYY.MM.DD')})</span></p>
            </div>
        </div>
    );
};